import {
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import axios from 'axios';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { ConfirmDialog, FormTitle } from 'components';
import { checkHost, updateRequest } from 'services';
import { renderRowCreatedAt } from 'utils/renderTableCell';
import { useSnackbar } from 'notistack';
import { activatedRequest, deactivatedRequest } from 'services/requests/update';
import { getMedia } from 'utils/getImage';
import { themesMockData } from 'mocks/themesMockData';

const INITIAL_STATE = {
  user: '',
  createdAt: '',
  host: '',
  theme: 1,
  image: null,
  address: '',
  about: '',
  phone: '',
  cv: '',
  title: '',
  type: '',
};

export const RequestDetailForm = () => {
  const [categoryCollapseState, setCategoryCollapseState] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [state, setState] = useState({});

  const profileRef = useRef();
  const navigate = useNavigate();
  const [request, setRequest] = useState(INITIAL_STATE);
  const { id } = useParams();

  const [productCategories, setProductCategories] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [categoryListCount, setCategoryListCount] = useState(0);
  const [allCategories, setAllCategories] = useState(false);
  const [open, setOpen] = useState(false);
  const [blob, setBlob] = useState(null);
  const [avatar, setAvatar] = useState(null);
  const [rejected, setRejected] = useState({
    site: state?._id,
    reason: '',
    description: '',
    notifyUser: false,
  });

  const [hostCheck, setHostCheck] = useState({
    ok: false,
    loading: false,
    checked: request?.host !== state?.host,
  });

  const getCategoryList = useCallback(async () => {
    try {
      const response = await axios.get('/admin/category/list');
      const { categories } = response.data;
      setCategoryListCount(response.data.categories.length);
      setCategoryList(categories);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const onAcceptRequest = async () => {
    try {
      // await updateRequest(request, state?._id, productCategories);
      // console.log(request);
      await updateRequest(request, state?._id, productCategories, allCategories);
      if (state.status !== 3) {
        await activatedRequest(state?._id);
      }
      enqueueSnackbar('با موفقیت ثبت شد', { variant: 'success' });
      navigate('/dashboard/request/new-request');
    } catch (error) {}
  };
  const onRejectRequest = async () => {
    try {
      await deactivatedRequest({ ...rejected, site: id });
      enqueueSnackbar('با موفقیت انجام شد', { variant: 'success' });
      navigate('/dashboard/request/new-request');
    } catch (error) {
      console.log(error);
    }
  };
  const onAvatarChange = (e) => {
    const imageBlob = URL.createObjectURL(e.target.files[0]);
    setBlob(imageBlob);
    setRequest({ ...request, image: e.target.files[0] });
  };
  const onUploadAvatar = async () => {
    if (!request.image) return;
    try {
      const body = new FormData();
      body.append('site', state?._id);
      body.append('file', request.image);
      const response = await axios.post('/admin/site/editAvatar', body);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };
  const onCheckHost = async () => {
    setHostCheck({ ...hostCheck, loading: true });
    try {
      setHostCheck({ ...hostCheck, loading: false, checked: true });
      const response = await checkHost(request.host);
      setHostCheck({ loading: false, ok: response.data.isAvailable, checked: true });
    } catch (error) {
      setHostCheck({ checked: true, loading: false, ok: false });
    }
  };

  useEffect(() => {
    getCategoryList();
  }, [getCategoryList]);

  useEffect(() => {
    axios
      .get(`/admin/site/search`, {
        params: {
          _id: id,
          page: 1,
          limit: 10,
        },
      })
      .then((res) => {
        setState(res.data?.data?.[0]);
      });
  }, [id]);

  useEffect(() => {
    setRequest({
      ...state,
      user: state?.user?._id,
      createdAt: state?.createdAt,
      host: state?.host,
      about: state?.config?.about?.data,
      phone: state?.config?.support?.phones[0],
      address: state?.config?.address?.plain,
      cv: state?.config?.cv?.data,
      theme: state?.config?.theme,
      productCategories: state?.config?.productCategories || [],
      productSubCategories: state?.config?.productSubCategories || [],
      title: state?.title,
      type: state.type,
    });
    setAvatar(state?.config?.avatar?.hash);
    setAllCategories(productCategories?.length === categoryList?.length);
    if (state?.config?.productCategories?.length === 0) {
      setProductCategories(categoryList);
      setAllCategories(true);
    } else {
      setProductCategories(state?.config?.productCategories);
    }
  }, [state, productCategories?.length, categoryList]);

  // useEffect(() => {
  //   if (productCategories.length === categoryList.length) {
  //     setAllCategories(true);
  //   } else {
  //     setAllCategories(false);
  //   }
  // }, [productCategories]);

  const categoryWithSub = useMemo(() => {
    const arr = [];

    productCategories?.map((cat) => {
      const childs = [];
      // PARENT WITH ALL CHILDS SELECTED
      if (cat?.children === undefined && !cat?.children?.length) {
        const category = categoryList.find((el) => el?._id === cat?.id);
        if (category) {
          category?.children?.forEach((z, i) => {
            childs.push(z);
          });
        }
        arr.push({ ...cat, children: childs });
      } else {
        const childsArr = [];
        cat?.children?.map((z) => {
          // ALL (PARENT + CHILDS)
          if (request?.productSubCategories?.length === 0 && productCategories?.length === categoryList?.length) {
            childsArr.push(z);
          } else if (request.productSubCategories?.some((c) => c.id === z._id)) {
            childsArr.push(z);
          }
          return z;
        });
        if (childsArr?.length) {
          arr.push({ ...cat, children: childsArr });
        }
      }

      return '';
    });

    // loop for subs and extract parent from categoryList
    categoryList?.forEach((cat) => {
      const childs = [];
      request?.productSubCategories?.forEach((child) => {
        if (cat?.children?.some((c) => c._id === child?.id)) {
          childs?.push(child);
        }
      });
      // in case of hasnt added before
      const isDuplicate = arr.find((el) => el?._id === cat?._id);
      if (childs?.length && isDuplicate === undefined) {
        arr.push({ ...cat, children: childs });
      }
    });

    return arr;
  }, [productCategories, request, categoryList]);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <TextField
            label="نام کاربری"
            fullWidth
            disabled
            value={request.user}
            onChange={(e) => setRequest({ ...request, user: e.target.value })}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="عنوان"
            fullWidth
            value={request?.title}
            onChange={(e) => setRequest({ ...request, title: e.target.value })}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField label="تاریخ درخواست" fullWidth value={renderRowCreatedAt('fa-IR', state?.createdAt)} />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="آدرس دامنه"
            fullWidth
            value={request.host}
            onChange={(e) => {
              setHostCheck({ ...hostCheck, checked: false });
              setRequest({ ...request, host: e.target.value });
            }}
            InputProps={{
              endAdornment: request.host !== state?.host && (
                <InputAdornment position="end">
                  {hostCheck.checked ? (
                    hostCheck.ok ? (
                      <Chip label="صحیح" variant="filled" sx={{ bgcolor: '#1DB954', color: '#fff' }} />
                    ) : (
                      <Chip label="نادرست" variant="filled" sx={{ bgcolor: '#E50450', color: '#fff' }} />
                    )
                  ) : (
                    <Button variant="contained" onClick={onCheckHost} disabled={hostCheck.loading}>
                      بررسی آدرس دامنه
                    </Button>
                  )}
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel>تم انتخابی</InputLabel>
            <Select
              label="تم انتخابی"
              value={request.theme}
              onChange={(e) => setRequest({ ...request, theme: e.target.value })}
            >
              {themesMockData.map((theme, index) => (
                <MenuItem key={index} value={theme.value}>
                  <ListItemText primary={theme.title} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6} />
        <Grid item>
          <FormTitle icon="profile_icon" label="اطلاعات شخصی" />
        </Grid>
        <Grid item xs={12}>
          <Typography>تصویر شخصی کاربر</Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              gap: '1rem',
              margin: '1rem 0',
            }}
          >
            <img
              src={blob || getMedia(avatar)}
              alt=""
              aria-hidden
              style={{
                width: '160px',
                height: '160px',
                borderRadius: '20px',
                boxShadow: '0px 12px 22px rgba(0, 0, 0, 0.09)',
                cursor: 'pointer',
              }}
              onClick={(e) => {
                profileRef.current.click();
                e.target.value = null;
              }}
            />
            <input hidden type="file" ref={profileRef} accept="image/*" onChange={onAvatarChange} />
            <Button variant="contained" sx={{ height: '48px' }} onClick={onUploadAvatar}>
              اصلاح تصویر
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <TextField
            multiline
            minRows={6}
            label="درباره ما"
            fullWidth
            placeholder="چند خط درباره کاربر"
            value={request.about}
            onChange={(e) => setRequest({ ...request, about: e.target.value })}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="شماره تماس پشتیبانی"
            fullWidth
            placeholder="شماره تماس پشتیبانی"
            value={request.phone}
            onChange={(e) => setRequest({ ...request, phone: e.target.value })}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="آدرس"
            fullWidth
            placeholder="آدرس"
            value={request.address}
            onChange={(e) => setRequest({ ...request, address: e.target.value })}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            multiline
            minRows={6}
            label="سوابق کاری"
            fullWidth
            placeholder="سوابق کاری"
            value={request.cv}
            onChange={(e) => setRequest({ ...request, cv: e.target.value })}
          />
        </Grid>

        {/* <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={categoryListCount === productCategories.length || allCategories}
                onClick={() => {
                  setAllCategories(!allCategories);
                  if (allCategories) {
                    setProductCategories([]);
                  } else {
                    setProductCategories(categoryList.map(({ _id }) => _id));
                  }
                }}
              />
            }
            label="همه ی دسته بندی ها"
          />
        </Grid> */}
        <FormTitle
          icon="box_icon"
          label="دسته بندی ها"
          needApprove={false}
          has_collapse
          collapseState={categoryCollapseState}
          onCollapseChange={() => setCategoryCollapseState(!categoryCollapseState)}
        />
        {categoryCollapseState && (
          <>
            <Grid item xs={12} style={{ paddingTop: '0px' }}>
              {categoryWithSub?.map((cat, index) => (
                <div style={{ display: 'block', margin: '25px 0px' }} key={index}>
                  <Typography sx={{ fontSize: '14px', color: '#222', fontWeight: 700 }}>{cat?.name}</Typography>
                  <Stack
                    flexDirection="row"
                    mt={2}
                    flexWrap="wrap"
                    justifyContent="flex-start"
                    alignItems="center"
                    gap={1}
                  >
                    {cat?.children?.map((z, i) => (
                      <Chip
                        key={i}
                        label={z?.name}
                        sx={{ direction: 'rtl' }}
                        onDelete={() => {
                          // handleCheckCategory(product._id)
                        }}
                        deleteIcon={<></>}
                      />
                    ))}
                  </Stack>
                </div>
              ))}
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <Stack flexDirection="row" justifyContent="flex-end" gap={1}>
            <Button
              variant="contained"
              size="large"
              sx={{
                width: 300,
                bgcolor: '#E50450',
                '&:hover': {
                  bgcolor: '#ab003a',
                },
              }}
              onClick={() => setOpen(true)}
            >
              رد درخواست
            </Button>
            <Button variant="contained" size="large" sx={{ width: 300 }} onClick={onAcceptRequest}>
              {state.status === 3 ? 'ویرایش درخواست' : 'تایید درخواست'}
            </Button>
          </Stack>
        </Grid>
      </Grid>
      <ConfirmDialog
        open={open}
        onClose={() => setOpen(false)}
        rejected={rejected}
        setRejected={setRejected}
        action={onRejectRequest}
      />
    </>
  );
};
